import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
  Optional,
  Inject
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ConfigStateService } from "../../../../../app/config/config-state.service";
import {
  AssigneeService,
  ClientService
} from "../../../../../../swaggerServices";
import { ActivatedRoute } from "@angular/router";
import { IClient } from "../../../../../app/sidebar/client-sidebar/client-sidebar.component";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "bulk-move-assignees",
    templateUrl: "./bulk-move-assignees.component.html",
    styleUrls: ["./bulk-move-assignees.component.scss"],
    standalone: false
})
export class BulkMoveAssigneesComponent implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() currentClientId;
  @Input() currentPopulationId;
  @Input() taxpayerAlias: string;
  @Output() completed = new EventEmitter();

  responseData = [];
  year = null;
  moveAssigneeResponse = [];
  bulkActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  showMoveAssigneeModal: boolean = false;
  showClientOption = true;
  clientList = [];
  populationList = [];
  clientId = "";
  populationId = "";
  errorMessage = "";

  private unsubscribe: Subject<void> = new Subject();
  constructor(
    private clientService: ClientService,
    private assigneeService: AssigneeService,
    private config: ConfigStateService,
    private route: ActivatedRoute,
    @Optional() private dialogRef?: MatDialogRef<BulkMoveAssigneesComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<BulkMoveAssigneesComponent>
  ) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns
      ? Object.keys(this.selectedTaxReturns).map(n => Number(n))
      : [];
  }

  get submitButtonDisabled() {
    return (
      !this.clientId || !this.populationId || this.bulkActionState === "LOADING"
    );
  }

  ngOnInit() {
    this.showMoveAssigneeModal = true;
    if (this.selectedTaxReturnIds.length <= 0) {
      return;
    }

    this.year = this.selectedTaxReturns[this.selectedTaxReturnIds[0]].year;
    if (this.currentClientId) this.clientId = this.currentClientId;
    if (
      this.currentClientId &&
      !this.config.featureFlags.moveAssigneeToDifferentClient
    ) {
      this.showClientOption = false;
    }
    this.getClientList();
    this.getPopulationList();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  moveAssignees() {
    if (parseInt(this.populationId) === parseInt(this.currentPopulationId)) {
      this.errorMessage = "Cannot move tax payers to the same population";
      return;
    }
    if (this.populationId && this.selectedTaxReturnIds.length > 0) {
      this.bulkActionState = "LOADING";
      const taxReturnIds = this.selectedTaxReturnIds.map(
        id => this.selectedTaxReturns[id].id
      );
      this.assigneeService
        .bulkMoveAssigneeToPopulation({
          taxReturnIds,
          populationId: parseInt(this.populationId)
        })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (resp: any) => {
            if (resp) {
              this.responseData = resp.map(r => {
                return {
                  ...r,
                  taxreturnId: this.selectedTaxReturnIds.find(
                    id => this.selectedTaxReturns[id].id === r.id
                  )
                };
              });
              this.bulkActionState = "COMPLETED";
            }
          },
          error => {
            this.errorMessage = "Something went wrong, please try again later.";
            this.bulkActionState = "OPENED";
            return;
          }
        );
    }
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.showMoveAssigneeModal = false;
    this.completed.emit();
  }

  changeClient() {
    this.getPopulationList();
  }

  private getClientList() {
    this.clientService
      .getClients(this.year)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((clients: IClient[]) => {
        this.clientList = clients.filter(c => c.status === 0);
      });
  }

  private getPopulationList() {
    if (this.clientId) {
      this.clientService
        .getClientById(parseInt(this.clientId), this.year)
        .subscribe((client: IClient) => {
          this.populationList = client.populations.filter(p => p.status === 0);
        });
    }
  }
}
